<div class="keisha-meisai-wrapper">
  <div class="main-panel" *ngIf="!modal">
    <div fxLayout="column">

      <div fxLayout="row wrap" fxLayoutGap="24px">
        <ng-select style="width: 200px;"
                   [items]="masterService.keishaMaster | isDeletedFilter:false"
                   bindLabel="farmKeisha"
                   placeholder="鶏舎名"
                   [closeOnSelect]="true"
                   [multiple]="false"
                   [required]="true"
                   [(ngModel)]="selectedKeisha"
                   [clearable]="false"
                   (change)="onChangeKeisha()"
                   name="selectedKeisha">
        </ng-select>
        <mat-form-field appearance="legacy">
          <mat-label>実施日</mat-label>
          <input matInput [matDatepicker]="selectedHibetsuDatePicker" [(ngModel)]="selectedHibetsuDate" name="selectedHibetsuDate" readonly
                 (click)="selectedHibetsuDatePicker.open()" [max]="commonService.getDateWithString()" (dateChange)="selectedDateChange(selectedHibetsuDate)">
          <mat-datepicker-toggle matSuffix [for]="selectedHibetsuDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #selectedHibetsuDatePicker disabled="false"></mat-datepicker>
        </mat-form-field>
        <span class="fill-remaining-space"></span>
        <div fxLayout="column">
          <button mat-raised-button
                  style="height: 40px"
                  color="primary"
                  type="button"
                  (click)="openSagyouKirokuCSVExportDailog()">
            <span class="label-for-icon-button">作業記録CSV</span>
          </button>
          <span class="fill-remaining-space"></span>
        </div>
        <button *ngIf="selectedKeishaHibetsuFile"
                mat-raised-button
                color="primary"
                style="height: 40px"
                (click)="updateKeishaHibetsuFile()">
          更新
        </button>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="24px">
        <ng-container *ngIf="selectedKeishaHibetsuFile">
          <mat-form-field class="input-margin" style="width: 200px; margin-right: 10px">
            <mat-label>
              登録者(午前)
            </mat-label>
            <input matInput placeholder="登録者(午前)" type="text"
                   name="operatorAM" [(ngModel)]="selectedKeishaHibetsuFile.operatorAM">
          </mat-form-field>
          <mat-form-field class="input-margin" style="width: 200px; margin-right: 10px">
            <mat-label>
              登録者(午後)
            </mat-label>
            <input matInput placeholder="登録者(午後)" type="text"
                   name="operatorPM" [(ngModel)]="selectedKeishaHibetsuFile.operatorPM">
          </mat-form-field>
        </ng-container>
      </div>
      <div fxLayout="column wrap" fxLayoutGap="24px">
        <mat-tab-group mat-align-tabs="start"
                       [(selectedIndex)]="meisaiTabIndex">
          <ng-container *ngFor="let tabName of meisaiTabNames">
            <mat-tab label="{{tabName}}" style="width: 40px"></mat-tab>
          </ng-container>
        </mat-tab-group>
        <div>
          <div *ngIf="selectedKeishaHibetsuFile && selectedKeisha; else outOfPeriod" style="padding-top: 24px">
            <div *ngIf="meisaiTabNames[meisaiTabIndex] === '温度'">
              <ng-container *ngTemplateOutlet="temperature"></ng-container>
            </div>
            <div *ngIf="meisaiTabNames[meisaiTabIndex] === '餌・水'">
              <ng-container *ngTemplateOutlet="feedWater"></ng-container>
            </div>
            <div *ngIf="meisaiTabNames[meisaiTabIndex] === '点灯'">
              <ng-container *ngTemplateOutlet="tentou"></ng-container>
            </div>
            <div *ngIf="meisaiTabNames[meisaiTabIndex] === '異常'">
              <ng-container *ngTemplateOutlet="abnormal"></ng-container>
            </div>
            <div *ngIf="meisaiTabNames[meisaiTabIndex] === '作業'">
              <ng-container *ngTemplateOutlet="sagyou"></ng-container>
            </div>
          </div>
        </div>
      </div>

      <ng-template #temperature>
        <ng-container *ngIf="selectedKeishaHibetsuFile">
          <div fxLayout="row wrap">
            <div *ngFor="let floor of keishaFloorArray" style="margin-right: 20px">
              <h2>{{floor}}階</h2>
              <div fxLayout="row">
                <div *ngFor="let amPm of ['AM','PM']">
                  <table class="shared-kiroku">
                    <thead>
                    <tr>
                      <th>
                        <span *ngIf="amPm === 'AM'" style="font-weight: normal">午前</span>
                        <span *ngIf="amPm === 'PM'" style="font-weight: normal">午後</span>
                      </th>
                      <th>最高</th>
                      <th>現在</th>
                      <th>最低</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let position of ['Front', 'Middle', 'Rear']">
                      <td *ngIf="position==='Front'">前</td>
                      <td *ngIf="position==='Middle'">中</td>
                      <td *ngIf="position==='Rear'">後</td>
                      <td *ngFor="let status of ['high', 'current', 'low']">
                        <!--                            <span [innerText]="selectedKeishaHibetsuFile[status + 'Temperature' + floor + position + amPm]-->
                        <!--                                               ? selectedKeishaHibetsuFile[status + 'Temperature' + floor + position + amPm] : ''">-->
                        <!--                            </span>-->
                        <input matInput
                               type="number"
                               [(ngModel)]="selectedKeishaHibetsuFile.temperature[status + 'Temperature' + floor + position + amPm]">
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div><br>
            </div>
          </div>
          <h2>外気温</h2>
          <div>
            <table class="shared-kiroku" style="margin-top: 12px">
              <thead>
              <tr>
                <th>最高</th>
                <th>最低</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td *ngFor="let gaikionPropertyName of gaikionProperties">
                  <input matInput
                         type="number"
                         [(ngModel)]="selectedKeishaHibetsuFile.temperature[gaikionPropertyName]">
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-template>
      <ng-template #feedWater>
        <ng-container *ngIf="selectedKeishaHibetsuFile">
          <h2>給水量</h2>
          <table class="shared-kiroku" style="width: 100%; margin-bottom: 20px">
            <thead>
            <tr>
              <th rowspan="2" style="width: 40px">給水量</th>
              <ng-container *ngFor="let floor of keishaFloorArray">
                <th colspan="2">{{floor + '　階'}}</th>
              </ng-container>
            </tr>
            <tr>
              <ng-container *ngFor="let floor of keishaFloorArray">
                <th>水道メーター</th>
                <th>差</th>
              </ng-container>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>前日</td>
              <ng-container *ngFor="let floor of keishaFloorArray">
                <td>
                  <input matInput
                         [(ngModel)]="selectedKeishaHibetsuFile.suidouMeter['latestSuidouMeter' + floor]"
                         type="number"
                         [step]="keishaHibetsuFileService.suidouMeterStep()"
                         (ngModelChange)="keishaHibetsuFileService.suidouMeterThroughMaxMin(selectedKeishaHibetsuFile,'latestSuidouMeter' + floor)">
                </td>
                <td>{{'－'}}</td>
              </ng-container>
            </tr>
            <tr>
              <td>午前</td>
              <ng-container *ngFor="let floor of keishaFloorArray">
                <td>
                  <input matInput
                         [(ngModel)]="selectedKeishaHibetsuFile.suidouMeter['suidouMeterAM' + floor]"
                         type="number"
                         [step]="keishaHibetsuFileService.suidouMeterStep()"
                         (ngModelChange)="keishaHibetsuFileService.suidouMeterThroughMaxMin(selectedKeishaHibetsuFile,'suidouMeterAM' + floor)">
                </td>
                <td>
                  {{commonService.diffSuidouMeter_m3('AM', selectedKeishaHibetsuFile, floor)}}
                  <ng-container *ngTemplateOutlet="cubicMeter"></ng-container>
                </td>
              </ng-container>
            </tr>
            <tr>
              <td>午後</td>
              <ng-container *ngFor="let floor of keishaFloorArray">
                <td>
                  <input matInput
                         [(ngModel)]="selectedKeishaHibetsuFile.suidouMeter['suidouMeterPM' + floor]"
                         type="number"
                         [step]="keishaHibetsuFileService.suidouMeterStep()"
                         (ngModelChange)="keishaHibetsuFileService.suidouMeterThroughMaxMin(selectedKeishaHibetsuFile,'suidouMeterPM' + floor)">
                </td>
                <td>
                  {{commonService.diffSuidouMeter_m3('PM', selectedKeishaHibetsuFile, floor)}}
                  <ng-container *ngTemplateOutlet="cubicMeter"></ng-container>
                </td>
              </ng-container>
            </tr>
            </tbody>
          </table>

          <h2>給餌量</h2>
          <table class="shared-kiroku" style="width: 100%;margin-bottom: 20px">
            <thead>
            <tr>
              <th *ngIf="!selectedKeisha.inputKyujiRyou">搬送メーター</th>
              <th>搬送量（ｋｇ）</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td *ngIf="!selectedKeisha.inputKyujiRyou">
                <!--                    {{selectedKeishaHibetsuFile.hansouMeter}}-->
                <input matInput
                       type="time"
                       step="2"
                       (click)="keishaHibetsuFileService.initMeterWhenEmpty(selectedKeishaHibetsuFile)"
                       [(ngModel)]="selectedKeishaHibetsuFile.hansouMeter"
                       (ngModelChange)="keishaHibetsuFileService.calcHansouRyou(selectedKeishaHibetsuFile, selectedKeisha)">
              </td>
              <td>
                <input matInput
                       type="number"
                       [disabled]="!selectedKeisha.inputKyujiRyou"
                       [(ngModel)]="selectedKeishaHibetsuFile.hansouRyou">
              </td>
            </tr>
            </tbody>
          </table>

          <ng-container *ngIf="selectedKeisha.calcEsaZan">
            <h2>入荷量</h2>
            <table class="shared-kiroku" style="width: 100%;margin-bottom: 20px">
              <thead>
              <tr>
                <th>入荷量（ｋｇ）</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <input matInput
                         type="number" min="0"
                         [(ngModel)]="selectedKeishaHibetsuFile.esaNyuukaRyou">
                </td>
              </tr>
              </tbody>
            </table>
          </ng-container>

          <h2>餌タンク残量</h2>
          <table class="shared-kiroku" style="width: 100%;margin-bottom: 20px">
            <thead>
            <tr>
              <th *ngFor="let i of feedTankArray">
                {{commonService.feedTankLabel(feedTankArray, i)}}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td *ngFor="let i of feedTankArray">
                <div fxLayout="row" fxLayoutAlign="center">
                  <ng-select [items]="feedTankObjList"
                             style="width: 200px;"
                             bindLabel="ton"
                             bindValue="kg"
                             appendTo="body"
                             [multiple]="false"
                             [clearable]="false"
                             [disabled]="selectedKeisha.calcEsaZan"
                             [(ngModel)]="selectedKeishaHibetsuFile.esaZan['esaZan' + i]"
                             name="hibetuFileEsaZan{{i}}">
                  </ng-select>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

          <h2>餌種別</h2>
          <div *ngIf="selectedKeishaHibetsuFile">
            <ng-select style="width: 200px;"
                       [items]="feedShubetsuList"
                       bindLabel="feedShubetsu"
                       placeholder="餌"
                       [closeOnSelect]="true"
                       [multiple]="false"
                       [required]="true"
                       [(ngModel)]="selectedKeishaHibetsuFile.feed"
                       [clearable]="false"
                       name="graphSelect">
            </ng-select>
          </div>
        </ng-container>
      </ng-template>
      <ng-template #abnormal>
        <ng-container *ngIf="selectedKeishaHibetsuFile">
          <form fxLayout="row" fxLayoutAlign="space-between">
            <div fxLayout="column wrap" fxLayoutGap="24px">
              <div *ngFor="let property of abnormalKeys">
                <ng-container *ngIf="commonService.checkIsObjectKey(abnormalProperties, property)">
                  <label fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start">
                    <mat-checkbox [(ngModel)]="selectedKeishaHibetsuFile[property]"
                                  name="{{property}}"
                                  (ngModelChange)="onClickAbnormalProperty(property);">
                    </mat-checkbox>
                    <div>{{abnormalProperties[property]}}</div>
                  </label>
                </ng-container>
              </div>
            </div>
            <div *ngIf="isAbnormalState" fxLayout="column wrap" fxLayoutGap="10px" style="width: 50%">
              <div *ngFor="let property of taiouKeys">
                <ng-container *ngIf="commonService.checkIsObjectKey(taiouProperties, property)">
                  <label fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start">
                    <mat-checkbox [(ngModel)]="selectedKeishaHibetsuFile[property]"
                                  name="{{property}}"
                                  (ngModelChange)="keishaHibetsuFileService.onClickTaiouProperty(selectedKeishaHibetsuFile, property);">
                    </mat-checkbox>
                    <div>{{taiouProperties[property]}}</div>
                  </label>
                </ng-container>
              </div>
            </div>
          </form>
        </ng-container>
      </ng-template>
      <ng-template #sagyou>
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="24px">
          <div class="today-operation" style="width: 50%" *ngIf="selectedKeishaHibetsuFile">
          <textarea matInput style="height: 200px" type="text" placeholder="作業内容" [(ngModel)]="selectedKeishaHibetsuFile.operation">
          </textarea>
          </div>
          <div fxLayout="column wrap" fxLayoutGap="10px" style="width: 50%">
            <h3>作業者</h3>
            <ng-container *ngFor="let operator of selectedKeishaHibetsuFile.operatorList;let index = index">
              <label fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start">
                <mat-checkbox style="margin-right:24px"
                              [(ngModel)]="operator.worked"
                              name="operator{{index}}">
                </mat-checkbox>
                <div>{{operator.name}}</div>
              </label>
            </ng-container>
          </div>
        </div>
      </ng-template>
      <ng-template #cubicMeter>
        m<span style="vertical-align: super; font-size: x-small">3</span>
      </ng-template>
      <ng-template #tentou>
        <div fxLayout="column wrap" fxLayoutGap="12px"
             *ngIf="selectedKeishaHibetsuFile && selectedKeishaHibetsuFile.tentouShoutouJikoku?.length">
          <ng-container *ngTemplateOutlet="tentous;"></ng-container>
        </div>
      </ng-template>

    </div>
  </div>
  <!--    作業登録画面からの入力用-->
  <div *ngIf="modal" class="modal-panel">
    <h3>餌・点灯の登録</h3>
    <div fxLayout="row wrap" fxLayoutGap="24px">
      <ng-select style="width: 200px;"
                 [items]="masterService.keishaMaster | isDeletedFilter:false"
                 bindLabel="farmKeisha"
                 placeholder="鶏舎名"
                 [closeOnSelect]="true"
                 [multiple]="false"
                 [required]="true"
                 [(ngModel)]="selectedKeisha"
                 [clearable]="false"
                 (change)="onChangeKeisha()"
                 name="selectedKeisha">
      </ng-select>
      <mat-form-field appearance="legacy" style="padding-top: 10px;padding-bottom: 10px;width: 200px;">
        <mat-label>取得日付</mat-label>
        <input matInput [matDatepicker]="referenceDatePicker" [(ngModel)]="selectedHibetsuDate" name="referenceDatePicker" readonly
               (click)="referenceDatePicker.open()" [max]="commonService.getDateWithString()" (dateChange)="selectedDateChange(selectedHibetsuDate)">
        <mat-datepicker-toggle matSuffix [for]="referenceDatePicker"></mat-datepicker-toggle>
        <mat-datepicker touchUi #referenceDatePicker disabled="false"></mat-datepicker>
      </mat-form-field>
    </div>
    <div fxLayout="column" fxLayoutGap="24px">
      <form #formEsaTentou="ngForm">
        <div *ngIf="selectedKeishaHibetsuFile">
          <ng-select style="width: 200px;"
                     [items]="feedShubetsuList"
                     bindLabel="feedShubetsu"
                     placeholder="餌*"
                     [closeOnSelect]="true"
                     [multiple]="false"
                     [required]="true"
                     [(ngModel)]="selectedKeishaHibetsuFile.feed"
                     [clearable]="false"
                     name="feed">
          </ng-select>
        </div>
        <div fxLayout="column" fxLayoutGap="12px"
             *ngIf="selectedKeishaHibetsuFile && selectedKeishaHibetsuFile.tentouShoutouJikoku?.length; else outOfPeriod">
          <ng-container *ngTemplateOutlet="tentous;"></ng-container>
        </div>
      </form>
      <div fxLayout="row wrap">
<!--        <span class="fill-remaining-space"></span>-->
        <div [matTooltip]="commonService.getAlertTooltipMessage(formEsaTentou)"
             matTooltipPosition="right"
             style="width: fit-content">
          <button mat-button mat-flat-button color="primary" style="display: inline-block;margin-right: 10px; max-height: 40px;"
                  (click)="updateKeishaHibetsuFile()">登録</button>
        </div>
      </div>
    </div>
  </div>
  <ng-template #tentouForm
               let-header="header"
               let-tentouJikanKey="tentouJikanKey"
               let-tentouShoutouJikan="tentouShoutouJikan">
    <h3 style="color: rgba(0, 0, 0, 0.54);width: 300px"
    [matTooltip]="tentouJikanKey === 'warikomiTentouJikan' ? '「割り込み時間」に登録した値が\n翌日以降の点灯消灯時刻となります。': ''"
        matTooltipClass="multiline-tooltip">{{header}}</h3>
    <div fxLayout="row wrap" fxLayoutGap="12px">
      <mat-form-field class="input-margin" style="margin-right: 10px" class="tentou-input">
        <mat-label>
          点灯時刻
        </mat-label>
        <input matInput placeholder="点灯時刻" type="time" [disabled]="tentouJikanKey === 'prevTentouJikan'"
               name="tentouJikoku{{tentouJikanKey}}" [(ngModel)]="tentouShoutouJikan[0].start" (ngModelChange)="genTentouJikan(tentouShoutouJikan, tentouJikanKey)">
      </mat-form-field>

      <mat-form-field class="input-margin" style="margin-right: 10px" class="tentou-input">
        <mat-label>
          消灯時刻
        </mat-label>
        <input matInput placeholder="消灯時刻" type="time" [disabled]="tentouJikanKey === 'prevTentouJikan'"
               name="shoutouJikoku{{tentouJikanKey}}" [(ngModel)]="tentouShoutouJikan[0].end" (ngModelChange)="genTentouJikan(tentouShoutouJikan, tentouJikanKey)">
      </mat-form-field>

      <mat-form-field class="input-margin" class="tentou-input">
        <mat-label>
          点灯時間
        </mat-label>
        <ng-container *ngIf="commonService.checkIsObjectKey(tentouJikan, tentouJikanKey)">
          <input matInput placeholder="点灯時間" type="time" [disabled]="tentouJikanKey === 'prevTentouJikan'"
                 name="tentouJikan{{tentouJikanKey}}" [(ngModel)]="tentouJikan[tentouJikanKey]" (ngModelChange)="refTentouJikanInShoutouJikoku(tentouShoutouJikan, tentouJikanKey)">
        </ng-container>
      </mat-form-field>
      <ng-container *ngIf="tentouJikanKey === 'warikomiTentouJikan'">
        <button mat-button mat-flat-button color="accent" style="display: inline-block;margin-right: 10px; max-height: 40px;"
                (click)="initWarikomiTentouJikan()">割り込み解除</button>
      </ng-container>
    </div>
  </ng-template>
  <ng-template #tentous>
    <ng-container *ngTemplateOutlet="tentouForm;
                context:{
                  header: '変更前',
                  tentouJikanKey: 'prevTentouJikan',
                  tentouShoutouJikan: prevTentouShoutouJikan
                }"></ng-container>
    <ng-container *ngTemplateOutlet="tentouForm;
                context:{
                  header: '変更後',
                  tentouJikanKey: 'tentouJikan',
                  tentouShoutouJikan: selectedKeishaHibetsuFile.tentouShoutouJikoku
                }"></ng-container>
    <ng-container *ngTemplateOutlet="tentouForm;
                context:{
                  header: '割り込み時間',
                  tentouJikanKey: 'warikomiTentouJikan',
                  tentouShoutouJikan: selectedKeishaHibetsuFile.warikomiTentouShoutouJikoku
                }"></ng-container>
  </ng-template>
  <ng-template #outOfPeriod>
    <div style="color: #999999;padding-left: 2em;padding-top: 2em">
      <span>
        飼養期間外の日付です。
      </span>
    </div>
  </ng-template>
</div>
